import { render, staticRenderFns } from "./DocumentLinksTableSingle.vue?vue&type=template&id=79e495e0&"
import script from "./DocumentLinksTableSingle.vue?vue&type=script&lang=js&"
export * from "./DocumentLinksTableSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports